import styled from "styled-components";

const bp = { md: "768px" };

const colors = {
  bg: "#fff7f8",

  white: "#ffffff",
  text: "#201512",
  textSoft: "#5f524b",
  textMuted: "#80716a",

  brown: "#2b1d17",
  brownDark: "#170f0c",

  gold: "#c9a227",
  goldDark: "#94703c",
  goldSoft: "#f4e7d1",

  pink: "#d596ad",
  pinkDark: "#ab647e",

  border: "#ddc9ac",
  borderSoft: "#e8d9c4",

  successText: "#0f5c35",
  successBg: "#e6f5eb",
  successBorder: "#bddcc8",

  dangerText: "#944761",
  dangerBg: "#fff0f5",
  dangerBorder: "#e7c3cf",
};

export const PageWrap = styled.div`
  min-height: 100vh;
  padding: 95px 40px 36px;
  background:
    radial-gradient(
      circle at top right,
      rgba(217, 163, 180, 0.12),
      transparent 22%
    ),
    radial-gradient(
      circle at top left,
      rgba(199, 165, 106, 0.08),
      transparent 24%
    ),
    linear-gradient(180deg, #fffaf7 0%, ${colors.bg} 100%);

  @media (max-width: 1024px) {
    padding: 96px 28px 30px;
  }

  @media (max-width: 768px) {
    padding: 78px 16px 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  margin-bottom: 28px;
`;

export const HeaderLeft = styled.div`
  width: 100%;
  display: flex;
`;

export const HeaderCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HeaderRight = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 1080px) {
    justify-content: center;
  }
`;

export const HeaderBottom = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 390px minmax(0, 1fr);
  gap: 22px;
  align-items: center;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const Title = styled.h1`
  margin: 6px 0 10px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.92);
  text-align: center;

  @media (max-width: ${bp.md}) {
    font-size: 26px;
    letter-spacing: 0.12em;
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  max-width: 760px;
  font-size: 15px;
  line-height: 1.6;
  color: ${colors.textSoft};
`;

export const Ornament = styled.div`
  position: relative;
  width: 260px;
  height: 14px;
  margin: 4px auto 14px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(201, 162, 39, 0.42);
  border-radius: 999px;
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) rotate(45deg);
  background: #c9a227;
  border-radius: 2px;
  box-shadow:
    0 0 0 3px rgba(201, 162, 39, 0.14),
    0 1px 2px rgba(0, 0, 0, 0.12);
`;

export const Badge = styled.div`
  padding: 10px 15px;
  border-radius: 999px;
  background: linear-gradient(135deg, #fffaf0 0%, #fff4f8 100%);
  border: 1px solid #e6d4b4;
  color: ${colors.goldDark};
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
`;

export const BackButton = styled.button`
  height: 46px;
  padding: 0 18px;
  border-radius: 14px;
  border: 1px solid #e7d3b2;
  background: linear-gradient(135deg, #fffaf1 0%, #fff2f8 100%);
  color: #6b4a55;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: linear-gradient(135deg, #fff5e7 0%, #ffedf5 100%);
  }
`;

export const FiltersBar = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 1.4fr) 1fr 1fr;
  gap: 12px;
  margin-bottom: 10px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchInput = styled.input`
  height: 50px;
  border-radius: 16px;
  border: 1.5px solid ${colors.border};
  padding: 0 16px;
  font-size: 14px;
  outline: none;
  background: rgba(255, 255, 255, 0.98);
  color: ${colors.text};
  box-shadow: 0 4px 10px rgba(35, 22, 17, 0.03);

  &:focus {
    border-color: ${colors.gold};
    box-shadow:
      0 0 0 4px rgba(201, 162, 39, 0.14),
      0 8px 18px rgba(201, 162, 39, 0.08);
  }
`;

export const FilterSelect = styled.select`
  height: 50px;
  border-radius: 16px;
  border: 1px solid ${colors.border};
  padding: 0 14px;
  font-size: 14px;
  outline: none;
  background: rgba(255, 255, 255, 0.95);
  color: ${colors.text};

  &:focus {
    border-color: ${colors.pinkDark};
    box-shadow: 0 0 0 4px rgba(185, 119, 141, 0.12);
  }
`;

export const InfoText = styled.div`
  font-size: 13px;
  color: ${colors.textMuted};
  margin-bottom: 18px;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCard = styled.div`
  border-radius: 24px;
  padding: 18px;
  background: ${({ $available }) =>
    $available
      ? "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(255,249,242,0.99) 100%)"
      : "linear-gradient(180deg, rgba(255,248,251,0.99) 0%, rgba(255,241,246,0.99) 100%)"};
  border: 1.5px solid
    ${({ $available }) => ($available ? "#d6b67d" : "#e1b8c6")};
  box-shadow:
    0 18px 40px rgba(53, 35, 25, 0.08),
    0 8px 20px rgba(217, 163, 180, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);
  transition: 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow:
      0 22px 46px rgba(53, 35, 25, 0.1),
      0 12px 26px rgba(217, 163, 180, 0.09);
  }
`;

export const ProductHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
`;

export const ProductTitleWrap = styled.div`
  min-width: 0;
`;

export const ProductName = styled.h3`
  margin: 0 0 6px;
  font-size: 20px;
  line-height: 1.2;
  color: ${colors.text};
`;

export const ProductCategory = styled.div`
  font-size: 13px;
  color: ${colors.textSoft};
`;

export const ProductStatus = styled.div`
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
  color: ${({ $ok }) => ($ok ? colors.successText : colors.dangerText)};
  background: ${({ $ok }) => ($ok ? colors.successBg : colors.dangerBg)};
  border: 1px solid
    ${({ $ok }) => ($ok ? colors.successBorder : colors.dangerBorder)};
`;

export const ProductBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(135deg, #fffdfa 0%, #fff6fa 100%);
  border: 1.3px solid ${colors.borderSoft};
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
`;

export const ToggleLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #463833;
`;

export const ToggleSwitch = styled.button`
  position: relative;
  width: 62px;
  height: 34px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: ${({ $active }) =>
    $active
      ? "linear-gradient(135deg, #76bb8d 0%, #4f8f63 100%)"
      : "linear-gradient(135deg, #e8d7dd 0%, #d7c7cf 100%)"};
  transition: 0.2s ease;
`;

export const ToggleThumb = styled.span`
  position: absolute;
  top: 4px;
  left: ${({ $active }) => ($active ? "32px" : "4px")};
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transition: 0.2s ease;
`;

export const StockRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(135deg, #fffdfa 0%, #fff8f0 100%);
  border: 1.3px solid ${colors.borderSoft};
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const StockLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #463833;
`;

export const StockInput = styled.input`
  width: 100%;
  height: 46px;
  border-radius: 14px;
  border: 1.5px solid ${colors.border};
  padding: 0 14px;
  font-size: 15px;
  font-weight: 800;
  outline: none;
  background: #fff;
  color: ${colors.text};
  box-shadow: inset 0 1px 2px rgba(41, 24, 18, 0.03);

  &:focus {
    border-color: ${colors.gold};
    box-shadow:
      0 0 0 4px rgba(199, 165, 106, 0.14),
      0 8px 18px rgba(199, 165, 106, 0.08);
  }

  &:disabled {
    background: #f2ebe4;
    color: #998b83;
    cursor: not-allowed;
    border-color: #dccdbc;
  }
`;

export const InfoBox = styled.div`
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid ${colors.border};
  color: ${colors.textSoft};
`;

export const EmptyState = styled.div`
  padding: 20px;
  border-radius: 18px;
  border: 1px dashed #dcc8a5;
  background: linear-gradient(135deg, #fffdf7 0%, #fff7fb 100%);
  color: ${colors.textSoft};
`;

export const ForbiddenWrap = styled.div`
  min-height: 70vh;
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  text-align: center;

  h2 {
    margin: 0;
    color: ${colors.text};
  }

  p {
    margin: 0;
    color: ${colors.textSoft};
  }
`;

export const MessageBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 20px;
  border-radius: 18px;
  border: 1px solid
    ${({ $type }) => ($type === "error" ? "#efc9d4" : "#d7e8d9")};
  background: ${({ $type }) =>
    $type === "error"
      ? "linear-gradient(135deg, #fff4f7 0%, #fff9fb 100%)"
      : "linear-gradient(135deg, #eef9f2 0%, #f9fdf9 100%)"};
`;

export const MessageIcon = styled.div`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
  color: #fff;
  background: ${({ $type }) =>
    $type === "error"
      ? "linear-gradient(135deg, #d07c98 0%, #b4617f 100%)"
      : "linear-gradient(135deg, #69a97d 0%, #4f8f63 100%)"};
`;

export const MessageContent = styled.div`
  flex: 1;
`;

export const MessageTitle = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #3d2d28;
  margin-bottom: 4px;
`;

export const MessageText = styled.div`
  font-size: 13px;
  line-height: 1.55;
  color: #6f625c;
`;

export const MessageClose = styled.button`
  border: none;
  background: transparent;
  color: #8d7c75;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
`;

export const ProductImageWrap = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 18px;
  overflow: hidden;
  border: 1.5px solid ${colors.borderSoft};
  background: linear-gradient(135deg, #fffdfa 0%, #fff3f8 100%);
  margin-bottom: 16px;
  position: relative;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 8px 18px rgba(35, 22, 17, 0.04);
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const ProductImageFallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.textMuted};
  font-size: 14px;
  font-weight: 700;
`;

export const ClosePageButton = styled.button`
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 99999;

  width: 46px;
  height: 46px;
  border-radius: 999px;
  border: 1px solid rgba(201, 162, 39, 0.38);

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(25, 22, 20, 0.92);
  color: #ff77b4;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 10px 24px rgba(0, 0, 0, 0.24);

  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.7);
    background: rgba(38, 32, 30, 0.98);
  }
`;
